export enum DonationStatus{
    ToContact = 1,
    Promised = 2,
    Paid = 3,
    Denied = 4,
}
